import { render, staticRenderFns } from "./LinkRedirects.vue?vue&type=template&id=26aa75c5&scoped=true"
import script from "./LinkRedirects.vue?vue&type=script&lang=js"
export * from "./LinkRedirects.vue?vue&type=script&lang=js"
import style0 from "./LinkRedirects.vue?vue&type=style&index=0&id=26aa75c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aa75c5",
  null
  
)

export default component.exports